export enum InputShape {
  SQUARE = 'SQUARE',
  ROUND = 'ROUND',
}

export const borderRadiusMap: { [key in InputShape]: string } = {
  [InputShape.ROUND]: '22px',
  [InputShape.SQUARE]: '4px',
};
